import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DestinationMaster_Create, DestinationMaster_Delete, DestinationMaster_ReadAll, DestinationMaster_ReadByTenantId, DestinationMaster_ReadById, DestinationMaster_Update } from "src/app/GlobalVariables";
import { DestinationMasterCreateRequestDTO, DestinationMasterDTO, DestinationMasterList, DestinationMasterReadByTenantIdRequestDTO, DestinationMasterReadByIdRequestDTO, DestinationMasterUpdateRequestDTO, DestinationMaterDeleteRequestDTO } from "./destination-master.interface";

@Injectable({
    providedIn: 'root'
})

export class DestinationMasterService {
    private http = inject(HttpClient);

    DestinationMaster_Create(data: DestinationMasterCreateRequestDTO): Observable<DestinationMasterDTO> {
        return this.http.post<DestinationMasterDTO>(DestinationMaster_Create, data);
    }

    DestinationMaster_Update(data: DestinationMasterUpdateRequestDTO): Observable<DestinationMasterDTO> {
        return this.http.post<DestinationMasterDTO>(DestinationMaster_Update, data);
    }

    DestinationMaster_Delete(data: DestinationMaterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(DestinationMaster_Delete, data);
    }

    DestinationMaster_ReadAll(): Observable<DestinationMasterList> {
        return this.http.get<DestinationMasterList>(DestinationMaster_ReadAll);
    }

    DestinationMaster_ReadById(data: DestinationMasterReadByIdRequestDTO): Observable<DestinationMasterDTO> {
        return this.http.post<DestinationMasterDTO>(DestinationMaster_ReadById, data);
    } 

    DestinationMaster_ReadByTenantId(data: DestinationMasterReadByTenantIdRequestDTO): Observable<DestinationMasterList> {
        return this.http.post<DestinationMasterList>(DestinationMaster_ReadByTenantId, data)
    }
}